module.exports = __webpack_public_path__ + "img/zhaoshang_kuaidi@2x.f14645b1.png";